import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-date-range', {
    mixins: [FormElementMixin],
    data() {
        return {
            removeFromListener: ['input','updateState','blur'],
            selectedDate: null,
            dateFormat: 'DD/MM/YYYY',
        }
    },
    watch: {
        selectedDate(newValue) {
            // if no date range is selected we set the currentValue back to NULL
            if (!newValue[0] && !newValue[1]) {
                this.currentValue = null;
                return;
            }

            const newValuesFormatted = newValue.map(date => {
                return this.$moment(date).toISOString(true);
            });

            if(!this.currentValue || (this.currentValue && ! this.$deepEqual(this.currentValue, newValuesFormatted))) {
                this.currentValue = newValuesFormatted;
            }
        },
        currentValue(newValue) {
            // if null we stop here
            if( ! newValue) {
                return;
            }

            const newDateValues = newValue.map(date => {
                return this.$moment(date).toDate(true);
            });

            if(! this.$deepEqual(this.selectedDate, newDateValues)) {
                this.selectedDate = newDateValues;
            }
        }
    },
    created() {
        if (this.currentValue) {
            this.selectedDate = this.currentValue.map(date => {
                return this.$moment(date).toDate(true);
            });
        }

    }
}, 'form/controls/ak-date-range.html');